module.exports = __webpack_public_path__ + "b9b9ee226a2f0e0821362034168d14ae.fbx";